import React from "react";
import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import Loader from "../ui/loader";
import { Toaster } from "react-hot-toast";
import breakpoints from "../../assets/styles/breakpoint";
import Header from "./header";
import { ThemeType, ThemeTypeEnum } from "../../assets/utils/validation/types";
import Footer from "./footer";
import background404Light from "../../assets/images/404.background-light.svg";
import background404Dark from "../../assets/images/404.background-dark.svg";
import { ModalWindowType } from "../ui/modal-window";

export interface LayoutProps {
  className: string;
  loaderState?: boolean;
  theme?: ThemeType;
  isNotFoundPage?: boolean;
  blockType?: string;
  enableUnsavedGuard?: boolean;
  isDirty?: boolean;
  modalWindow?: ModalWindowType;
  isMinHeight?: boolean;
}

const MainLayout: React.FC<React.PropsWithChildren<LayoutProps>> = ({
  className,
  children,
  loaderState,
  theme = ThemeTypeEnum.LIGHT,
  isNotFoundPage = false,
}) => {
  return (
    <>
      <MainDiv
        className={className}
         style={
    isNotFoundPage
      ? {
          backgroundImage: `url(${
            theme === ThemeTypeEnum.DARK ? background404Dark : background404Light
          })`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }
      : {}
  }
      >
        <Header theme={theme!} />
        {children}
        <Footer />
      </MainDiv>
      {loaderState && <Loader />}
      <Toaster
        toastOptions={{
          style: {
            padding: 0,
            margin: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
            width: "100%",
            maxWidth: "none",
          },
        }}
      />
    </>
  );
};

export default MainLayout;

const MainDiv = styled.div`
  width: 100%;
  min-height: 100vh;
  &::selection {
    color: ${COLORS.white};
    background: ${COLORS.blue};
  }

  ${breakpoints.lg} {
    background-position: left !important;
  }

  header,
  footer {
    padding: 30px 40px;
    width: 100%;

    ${breakpoints.xs} {
      padding: 24px 16px;
    }
  }

  header img {
    height: 44px;

    @media (max-width: 1024px) {
      height: 40px;
    }

    ${breakpoints.md} {
      height: 38px;
    }

    ${breakpoints.xs} {
      height: 34px;
    }
  }

  footer img {
    height: 26px;

    ${breakpoints.md} {
      height: 24px;
    }

    ${breakpoints.xs} {
      height: 22px;
      margin: 0 auto;
    }
  }
`;
